import React from 'react';
import FastFacts from './fast-facts';

/**
* This is the save component for the Fast Facts block.
*/

const SaveFastFacts = ({ attributes }) => {
  const { cards, textColorClass, headingColorClass, title } = attributes;

  return (
    <div className="fast-facts container-fluid">
      {/* Ensure there are cards for Fast Facts */}
      {cards && cards.length > 0 ? (
        <FastFacts
          title={title}
          cards={cards}
          textColorClass={textColorClass}
          headingColorClass={headingColorClass}
        />
      ) : (
        <p className="text-center">No Facts available.</p>
      )}
    </div>
  );
};

export default SaveFastFacts;
